export default {
  drinks: "GETRÄNKE",
  food: "LEBENSMITTEL",
  dessert: "DESSERT",
  first: "Zuerst",
  second: "Zweite",
  mainCourses: "HAUPTGÄNGE",
  comments: "Bemerkungen:",
  invoice: "Rechnung",
  cookies: "Kekse",
  privacy: "Privatsphäre",
  termsAndConditions: "Geschäftsbedingungen",
  noRecordMessage:
    "Keine Ergebnisse gefunden. Bitte überprüfen Sie die Suchfilter!",
  askFor: "Nachfragen",
  keep: "Halten",
  close: "Schließen",
  everything: "Alles",
  done: "Fertig",
  toShare: "TEILEN",
  companyName: "Name der Firma",
  postalCode: "Postleitzahl",
  town: "Cittadino",
  address: "Die Anschrift",
  nameIsRequired: "Name ist erforderlich",
  addressIsRequired: "Adresse ist erforderlich",
  NIFIsRequired: "NIF ist erforderlich",
  postalCodeIsRequired: "Postleitzahl ist erforderlich",
  cityIsRequired: "Stadt ist erforderlich",
  emailIsRequired: "E-Mail ist erforderlich",
  theEmailMustBeValid: "Die E-Mail muss gültig sein",
  charging: "Aufladen..."
};
